import { t } from '@lingui/core/macro';
import { NumberRangeFilter } from './NumberRangeFilter';
export const noticePeriodDaysFilterLabel = () => t({
    message: 'Notice period days',
    comment: 'Insights: Notice period days filter',
});
export function NoticePeriodDaysFilter() {
    return <NumberRangeFilter name="metadataDocumentNoticePeriodDays" label={noticePeriodDaysFilterLabel()}/>;
}
